$(document).on('click', '.js-preview', function(e) {
   // first find a parent row
    const $this = $(this);
    const $row = $this.closest('tr');

    if ( $row.length < 1 ) {
        return
    }

    const $cells = $row.find('td');

    if ( $cells.length < 0 ) {
        return
    }


    let content = `<div class="row">`;
    let comments = '';

    $cells.each(function() {
        const $item = $(this);
        const $title = $item.attr('data-title');
        if ( $title === 'Comments' ) {
            comments = `
            <p><strong>${$title}</strong></p>
            <p class="mb-3">${$item.text()}</p>
            `
            return
        }
        if (
            $title === 'Topic' ||
            $title === 'Surrey Link' ||
            $title === 'International' ||
            $title === 'Impact' ||
            $title === 'Average'
        ) {
            content += `
                <div class="col">
                    <p><strong>${$title}</strong></p>
                    <p class="mb-3">${$item.text()}</p>
                </div>
            `
            return
        }
        content += `
            <div class="col-12">
                <p><strong>${$title}</strong></p>
                <p class="mb-3">${$item.text()}</p>
            </div>
        `
    });


    const $placeholder = $('.js-previewEvaluationModal__placeholder');
    content += `</div>`
    $placeholder.html(content);
    $placeholder.append(comments);

    $('#preview_evaluation_modal').modal('show');
});
